import { createContext } from 'react';
import type { WsContextValue } from './types';

// ----------------------------------------------------------------------

const WsContext = createContext<WsContextValue | null>(null);

export default WsContext;
